"use client";
import style from "@/app/style/servicesetyle.module.css";
import React, { useState, useEffect } from "react";
import {
  FaArrowLeft,
  FaArrowRight,
  // cta bnner
} from "react-icons/fa";
import right from "../../../../public/updated-home/states/florida/Right.svg";
import left from "../../../../public/updated-home/states/florida/Left.svg";
import Image from "next/image";
import Link from "next/link";

function SliderIndicator({ index, activeIndex, onClick }) {
  return (
    <span
      onClick={() => onClick(index)}
      className={`h-2 w-2 bg-gray-500 rounded-full mx-1 display-desktop  cursor-pointer ${
        index === activeIndex ? "bg-[#D5AF34]" : "red"
      }`}
    />
  );
}

function ctabanner({ Mydata }) {
  const data = Mydata[2];
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < data.content.length - 1 ? prevIndex + 1 : 0
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : data.content.length - 1
    );
  };

  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    // Auto slide every 5 seconds
    const interval = setInterval(() => {
      handleNext();
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [currentIndex]);

  const currentContent = data.content[currentIndex];
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div>
      <div>
        <div id={style.stateCtaBanner} className={style[currentContent.image]}>
          <div className=" pt-12  grid grid-cols-12 mb-4">
            <div className="col-span-1 display flex items-center justify-center">
              {" "}
              <div className="col-span-1">
                <Image
                  src={left}
                  height={20}
                  width={20}
                  alt="left arrow"
                  title="left arrow"
                  className="text-4xl text-[#D5AF34] cursor-pointer mr-4"
                  onClick={handlePrev}
          
                  loading="lazy"
                />
              </div>
            </div>

            <div className=" px-6 col-span-12 sm:col-span-10 md:col-span-10 lg:col-span-10 ">
              <div className=" relative ">
                <div
                  style={{ background: "rgba(245, 245, 245, 1)" }}
                  className="mx-auto   px-[16px] visiontop  rounded-2xl lg:pb-10  max-w-7xl grid grid-cols-1  lg:gap-10  xl:px-10 relative"
                >
                  <div className="">
                    <h2
                      id="visionh2"
                      className="text-3xl secondary font-bold lg:text-center"
                    >
                      {currentContent.title}{" "}
                      <span className="text-[#D5AF34]">
                        {currentContent.subtitle}
                      </span>
                    </h2>
                    <p className="updatedparapremu pt-3 pb-10 sm:pb-10 md:pb-10  lg:pb-0 text-center">
                      {currentContent.des}
                    </p>
                  </div>
                  {/* Indicators */}
                  <div className="absolute bottom-4 left-0 right-0 flex justify-center">
                    {data.content.map((_, index) => (
                      <SliderIndicator
                        key={index}
                        index={index}
                        activeIndex={currentIndex}
                        onClick={handleIndicatorClick}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-span-1 display flex items-center justify-center">
              {" "}
              <div className="col-span-1">
                <Image
                  src={right}
                  height={20}
                  width={20}
                  alt="left arrow"
                  title="left arrow"
                  className="text-4xl text-[#D5AF34] cursor-pointer mr-4"
                  onClick={handlePrev}
           
                 loading="lazy"
                />
              </div>
            </div>
          </div>
          <div className="flex justify-center mx-auto max-w-7xl ">
            {/* <Link href=""> */}{" "}
            <button
              onClick={scrollTop}
              className="bg-bb pr-5 pl-5  pt-2  pb-2 rounded-2xl mb-3 "
            >
              BOOK NOW
            </button>
            {/* </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ctabanner;
